const ORANGE_TONE_SECONDS = 0.2
const ORANGE_TONE_FREQUENCY_HZ = 880

let audioContext = null
let interactionBound = false

function audioContextClass () {
  return window.AudioContext || window.webkitAudioContext || null
}

function sharedAudioContext () {
  const AudioContextClass = audioContextClass()
  if (!AudioContextClass) {
    return null
  }
  if (!audioContext) {
    audioContext = new AudioContextClass()
  }

  return audioContext
}

export function primeKitchenWaitAudio () {
  if (interactionBound || !audioContextClass()) {
    return
  }
  interactionBound = true

  const resume = () => {
    const context = sharedAudioContext()
    if (context && context.state === 'suspended') {
      context.resume()
    }
  }

  window.addEventListener('touchend', resume, { once: true })
  window.addEventListener('click', resume, { once: true })
}

export function playOrangeTone () {
  const context = sharedAudioContext()
  if (!context) {
    return
  }
  if (context.state === 'suspended') {
    context.resume()
  }

  const oscillator = context.createOscillator()
  oscillator.frequency.value = ORANGE_TONE_FREQUENCY_HZ
  oscillator.connect(context.destination)
  oscillator.start()
  oscillator.stop(context.currentTime + ORANGE_TONE_SECONDS)
}

export function closeKitchenWaitAudio () {
  if (audioContext) {
    audioContext.close()
    audioContext = null
  }
  interactionBound = false
}
